import React from "react";
import ReactDOM from "react-dom";

function renderHiddenTipNotification(id) {
  const target = document.getElementById(id);
  if (target) {
    ReactDOM.render(<></>, target);
  }
}

export async function hideTipNotification(id) {
  renderHiddenTipNotification(id);
}
